export function readPersistedWidth(key: string): number | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const n = Number.parseInt(raw, 10);
    if (!Number.isFinite(n) || n <= 0) return null;
    return n;
  } catch {
    return null;
  }
}

export function persistWidth(key: string, px: number): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, String(Math.round(px)));
  } catch {
    // Width persistence is a nicety; a failed write must not break the resize.
  }
}

export function readWidthBounds(
  prefix: string,
  fallbacks: { min: number; max: number; fallback: number },
): { min: number; max: number; fallback: number } {
  if (typeof window === "undefined") {
    return fallbacks;
  }
  const root = document.documentElement;
  const read = (name: string, fallback: number): number => {
    const raw = getComputedStyle(root).getPropertyValue(name).trim();
    const n = Number.parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  };
  return {
    min: read(`${prefix}-min-width`, fallbacks.min),
    max: read(`${prefix}-max-width`, fallbacks.max),
    fallback: read(`${prefix}-default-width`, fallbacks.fallback),
  };
}
